import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import HeaderExternal from '../../Components/HeaderExternal';

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

function RejectApproval() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const token = searchParams.get("token");

  const handleReject = () => {
    
    if (!token) {
      setMessage("Invalid approval link.");
      return;
    }

    if (!remark) {
      alert("Please enter a remark.");
      return;
    }

    setLoading(true);

    const url = `${REACT_APP_API}/api/Organization/Approval/RejectRequest?token=${encodeURIComponent(token)}&remark=${encodeURIComponent(remark)}`;

    fetch(url, {
      method: "POST"
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text);
        }
        return res.json();
      })
      .then((data) => {
        setMessage(data.message || "Request rejected successfully.");
      })
      .catch((error) => {
        console.error(error);
        setMessage("Invalid or expired approval link.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div>
        {message ? (
          <div className="container">
            <div className="box_shadow mt-5">
              <div className="col-md-12 text-center">
                <h2 className="inVlid">{message}</h2>
                <a href="/flight" className="btn btn-primary BackToRd">OK</a>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="box_shadow mt-5">
              <div className="col-md-12">
                <label className="required">Remark</label>
                <textarea
                  className="form-controls"
                  cols={80}
                  rows={4}
                  placeholder="Reason for reject"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                ></textarea>
              </div>
              <div className="col-md-12 text-end">
                <button className="btn btn-danger" onClick={handleReject} disabled={loading}>
                  {loading ? "Processing..." : "Reject Request"}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default RejectApproval;